import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  Typography,
} from "@mui/material";
import { GetAvailableThermometers } from "../../../services/GeneralMaintenanceService";

const ThermometerPickerDialog = ({ open, onClose, onSelect, excludeItemId }) => {
  const [thermometers, setThermometers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setSearch("");
    setLoading(true);
    GetAvailableThermometers(excludeItemId || 0)

      .then((data) => {
        const list = Array.isArray(data) ? data : data?.results;
        setThermometers(Array.isArray(list) ? list : []);
      })
      .catch(() => setThermometers([]))
      .finally(() => setLoading(false));
  }, [open, excludeItemId]);

  const filtered = thermometers.filter((t) => {
    const q = search.toLowerCase();
    return (
      (t.serialNumber || "").toLowerCase().includes(q) ||
      (t.description || "").toLowerCase().includes(q) ||
      (t.model || "").toLowerCase().includes(q)
    );
  });

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>Select Thermometer</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          size="small"
          fullWidth
          label="Search by serial, description, or model"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          sx={{ mb: 2, mt: 1 }}
        />
        {loading ? (
          <CircularProgress size={28} />
        ) : filtered.length === 0 ? (
          <Typography variant="body2" color="text.secondary">
            No available thermometers found.
          </Typography>
        ) : (
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell>Serial No</TableCell>
                <TableCell>Description</TableCell>
                <TableCell>Model</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered.map((t) => (
                <TableRow
                  key={t.itemId}
                  hover
                  onClick={() => onSelect(t.serialNumber)}
                  sx={{ cursor: "pointer" }}
                >
                  <TableCell>{(t.serialNumber || "").trim()}</TableCell>
                  <TableCell>{(t.description || "").trim()}</TableCell>
                  <TableCell>{(t.model || "").trim()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ThermometerPickerDialog;
